import React from 'react';

const Terms = () => {
  return (
    <main className="pt-32 pb-20">
      <div className="container-custom">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">
            Terms of Service
          </h1>
          
          <p className="text-gray-600 mb-8">
            Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
          </p>
          
          <div className="prose prose-lg max-w-none">
            <section className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Agreement to Terms</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Welcome to TheCouponers. These Terms of Service ("Terms") govern your access to and use of the thecouponers.com website and our browser extension (collectively, the "Service").
              </p>
              <p className="text-gray-600 leading-relaxed">
                By accessing or using our Service, you agree to be bound by these Terms. If you disagree with any part of the terms, you may not access the Service.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Description of Service</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                TheCouponers provides a coupon discovery and application service that helps users find and apply discount codes when shopping online. Our Service includes:
              </p>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                <li>A browser extension that automatically searches for and applies coupon codes at checkout</li>
                <li>A website directory of verified coupon codes and deals</li>
                <li>Price comparison tools</li>
                <li>Price tracking and alert features</li>
              </ul>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">User Accounts</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                While many features of our Service are available without an account, some features may require registration. When you create an account, you agree to:
              </p>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                <li>Provide accurate, current, and complete information</li>
                <li>Maintain and update your information to keep it accurate</li>
                <li>Maintain the security of your account credentials</li>
                <li>Accept responsibility for all activities that occur under your account</li>
                <li>Notify us immediately of any unauthorized use of your account</li>
              </ul>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Acceptable Use</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                You agree not to use the Service to:
              </p>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                <li>Violate any applicable laws or regulations</li>
                <li>Infringe upon the rights of others</li>
                <li>Submit false or misleading information</li>
                <li>Distribute spam, malware, or other harmful content</li>
                <li>Attempt to gain unauthorized access to our systems or networks</li>
                <li>Interfere with or disrupt the Service or servers</li>
                <li>Scrape, data mine, or use automated systems to access the Service without permission</li>
                <li>Use the Service for any fraudulent or illegal purpose</li>
                <li>Reverse engineer or attempt to extract the source code of our software</li>
              </ul>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Coupon Codes and Deals</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Regarding the coupon codes and deals displayed through our Service:
              </p>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                <li>We make reasonable efforts to verify coupon codes, but we cannot guarantee that all codes will work</li>
                <li>Coupon availability, terms, and validity are determined by the retailers, not by us</li>
                <li>Prices and discounts are subject to change without notice</li>
                <li>Some coupons may have restrictions, limitations, or eligibility requirements</li>
                <li>We are not responsible for errors in pricing, coupon codes, or product information</li>
              </ul>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Intellectual Property</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                The Service and its original content, features, and functionality are owned by TheCouponers and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.
              </p>
              <p className="text-gray-600 leading-relaxed">
                You may not copy, modify, distribute, sell, or lease any part of our Service without our prior written consent.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Third-Party Links and Services</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Our Service may contain links to third-party websites or services that are not owned or controlled by TheCouponers. We have no control over, and assume no responsibility for:
              </p>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                <li>The content, privacy policies, or practices of any third-party websites or services</li>
                <li>Any damage or loss caused by your use of third-party content or services</li>
              </ul>
              <p className="text-gray-600 leading-relaxed mt-4">
                We encourage you to review the terms and privacy policies of any third-party sites you visit.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Disclaimer of Warranties</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO:
              </p>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                <li>IMPLIED WARRANTIES OF MERCHANTABILITY</li>
                <li>FITNESS FOR A PARTICULAR PURPOSE</li>
                <li>NON-INFRINGEMENT</li>
                <li>ACCURACY OR RELIABILITY OF ANY CONTENT</li>
              </ul>
              <p className="text-gray-600 leading-relaxed mt-4">
                We do not warrant that the Service will be uninterrupted, secure, or error-free.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Limitation of Liability</h2>
              <p className="text-gray-600 leading-relaxed">
                TO THE MAXIMUM EXTENT PERMITTED BY LAW, THECOUPONERS SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING BUT NOT LIMITED TO LOSS OF PROFITS, DATA, USE, OR GOODWILL, RESULTING FROM YOUR ACCESS TO OR USE OF (OR INABILITY TO ACCESS OR USE) THE SERVICE, REGARDLESS OF THE CAUSE OF ACTION OR THE THEORY OF LIABILITY.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Indemnification</h2>
              <p className="text-gray-600 leading-relaxed">
                You agree to defend, indemnify, and hold harmless TheCouponers and its officers, directors, employees, and agents from any claims, damages, losses, liabilities, costs, or expenses (including reasonable attorneys' fees) arising from your use of the Service or violation of these Terms.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Termination</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                We may terminate or suspend your access to the Service immediately, without prior notice or liability, for any reason, including:
              </p>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                <li>Breach of these Terms</li>
                <li>Fraudulent, abusive, or illegal activity</li>
                <li>At our sole discretion for any other reason</li>
              </ul>
              <p className="text-gray-600 leading-relaxed mt-4">
                Upon termination, your right to use the Service will immediately cease.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Governing Law</h2>
              <p className="text-gray-600 leading-relaxed">
                These Terms shall be governed by and construed in accordance with the laws of the jurisdiction in which TheCouponers operates, without regard to its conflict of law provisions.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Changes to Terms</h2>
              <p className="text-gray-600 leading-relaxed">
                We reserve the right to modify or replace these Terms at any time at our sole discretion. If a revision is material, we will provide at least 30 days' notice prior to any new terms taking effect. Your continued use of the Service after any changes constitutes acceptance of the new Terms.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Severability</h2>
              <p className="text-gray-600 leading-relaxed">
                If any provision of these Terms is held to be unenforceable or invalid, such provision will be changed and interpreted to accomplish the objectives of such provision to the greatest extent possible under applicable law, and the remaining provisions will continue in full force and effect.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Contact Us</h2>
              <p className="text-gray-600 leading-relaxed">
                If you have any questions about these Terms, please contact us at:
              </p>
              <div className="bg-gray-50 rounded-xl p-6 mt-4">
                <p className="text-gray-600">
                  <strong>TheCouponers</strong><br />
                  Email: legal@thecouponers.com<br />
                  Website: thecouponers.com
                </p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Terms;
